{
  "primevue": {
    "accept": "確定",
    "reject": "取消",
    "choose": "選擇",
    "upload": "上傳",
    "cancel": "取消",
    "dayNames": [
      "星期日",
      "星期一",
      "星期二",
      "星期三",
      "星期四",
      "星期五",
      "星期六"
    ],
    "firstDayOfWeek": 0,
    "dayNamesShort": [
      "日",
      "一",
      "二",
      "三",
      "四",
      "五",
      "六"
    ],
    "dayNamesMin": [
      "日",
      "一",
      "二",
      "三",
      "四",
      "五",
      "六"
    ],
    "monthNames": [
      "一月",
      "二月",
      "三月",
      "四月",
      "五月",
      "六月",
      "七月",
      "八月",
      "九月",
      "十月",
      "十一月",
      "十二月"
    ],
    "monthNamesShort": [
      "1月",
      "2月",
      "3月",
      "4月",
      "5月",
      "6月",
      "7月",
      "8月",
      "9月",
      "10月",
      "11月",
      "12月"
    ],
    "today": "今天",
    "clear": "清除",
    "dateFormat": "yy-mm-dd",
    "weekHeader": "週",
    "aria": {
      "trueLabel": "真",
      "falseLabel": "假",
      "nullLabel": "未選擇",
      "star": "1 星",
      "stars": "{star} 星",
      "selectAll": "選擇所有項目",
      "unselectAll": "取消選擇所有項目",
      "close": "關閉",
      "previous": "上一個",
      "next": "下一個",
      "navigation": "導航",
      "scrollTop": "捲動至頂部",
      "nextPageLabel": "下一頁",
      "prevPageLabel": "上一頁",
      "firstPageLabel": "第一頁",
      "lastPageLabel": "最後一頁",
      "pageLabel": "第 {page} 頁",
      "rowsPerPageLabel": "每頁列數",
      "jumpToPageDropdownLabel": "跳至頁面下拉選單",
      "jumpToPageInputLabel": "跳至頁面輸入框",
      "selectRow": "已選取列",
      "unselectRow": "已取消選取列",
      "expandRow": "已展開列",
      "collapseRow": "已收合列",
      "showFilterMenu": "顯示篩選選單",
      "hideFilterMenu": "隱藏篩選選單",
      "filterOperator": "篩選運算子",
      "filterConstraint": "篩選條件",
      "editRow": "編輯列",
      "saveEdit": "儲存編輯",
      "cancelEdit": "取消編輯",
      "listView": "清單檢視",
      "gridView": "格狀檢視",
      "slide": "投影片",
      "slideNumber": "{slideNumber}",
      "zoomImage": "縮放圖片",
      "zoomIn": "放大",
      "zoomOut": "縮小",
      "rotateRight": "向右旋轉",
      "rotateLeft": "向左旋轉",
      "selectLabel": "選取",
      "unselectLabel": "取消選取",
      "removeLabel": "移除",
      "selectColor": "選擇顏色",
      "passwordShow": "顯示密碼",
      "passwordHide": "隱藏密碼",
      "moveTop": "移至頂端",
      "moveUp": "上移",
      "moveDown": "下移",
      "moveBottom": "移至底端",
      "moveToTarget": "移至目標",
      "moveToSource": "移回來源",
      "moveAllToTarget": "全部移至目標",
      "moveAllToSource": "全部移回來源"
    }
  }
}